import { defineStore } from "pinia";
import { useRotaStore } from "./rotas";
import {
  SHIFTCOVER_STATUS_PENDING,
  SHIFTCOVER_STATUS_VOLUNTEERED,
} from "@/lib/constants/shift-cover-requests";

export const useRotaShiftCoverStore = defineStore("rotashiftcover", {
  state: () => ({
    filter: {
      location: "all",
      duties: [],
      hideShiftsBeforeToday: true,
    },
    pendingApprovalsCount: null,
  }),

  localStorage: {
    // only persist the location
    toStorage: ({ filter: { location } }) => ({ filter: { location } }),
    // this $patches the filter.location
    fromStorage: (state) => state,
  },

  actions: {
    async pollPendingApprovals() {
      const rotaStore = useRotaStore();
      const approvalStates = [
        SHIFTCOVER_STATUS_PENDING,
        SHIFTCOVER_STATUS_VOLUNTEERED,
      ];

      let result = await rotaStore.getShiftCoverRequests();
      result = result.filter((r) =>
        approvalStates.includes(r.shift?.coverRequestStatus),
      );
      if (this.filter.location !== "all") {
        result = result.filter(
          (r) =>
            r.location.toLowerCase() === this.filter.location.toLowerCase(),
        );
      }
      this.pendingApprovalsCount = result.length;
    },
  },
});
